import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/** Applies a bulk-update payload to the local server-truth tag list optimistically. */
export function patchServerTags(current, updated, deleted) {
  var deletedIds = new Set(deleted.map(function (d) {
    return d.tag_id;
  }));
  var updatedMap = new Map(updated.map(function (u) {
    return [u.tag_id, u.response];
  }));
  var result = current.filter(function (t) {
    return !deletedIds.has(t.tag_id);
  }).map(function (t) {
    return updatedMap.has(t.tag_id) ? _objectSpread(_objectSpread({}, t), {}, {
      response: updatedMap.get(t.tag_id)
    }) : t;
  });
  updated.forEach(function (u) {
    if (!result.some(function (t) {
      return t.tag_id === u.tag_id;
    })) {
      result.push({
        tag_id: u.tag_id,
        response: u.response
      });
    }
  });
  return result;
}

/** Updates or inserts a single tag entry in the server-truth tag list optimistically. */
export function applyTagUpdate(current, tagId, response) {
  return current.some(function (t) {
    return t.tag_id === tagId;
  }) ? current.map(function (t) {
    return t.tag_id === tagId ? _objectSpread(_objectSpread({}, t), {}, {
      response: response
    }) : t;
  }) : [].concat(_toConsumableArray(current), [{
    tag_id: tagId,
    response: response
  }]);
}